import { units } from '@ui/css';
import { makeScalarToken, combineTokens } from '@utils/css';

const sheetAspectRatio = makeScalarToken("--sheet-page--aspect-ratio", 1);
const sheetTokens = combineTokens("--sheet", {
  zoom: 1,
  insetBlock: units.px(180),
  insetInline: units.px(250)
});
const sheetCls = "_086s4i3o7a";
const aspectContainer = "_086a1ged70x";
const zoomContainer = "_086zwd9mid";
const drawToolCls = "_086dnw34ff";

export { aspectContainer, drawToolCls, sheetAspectRatio, sheetCls, sheetTokens, zoomContainer };
import "./_sheet.style.linaria.module.css";
//# sourceMappingURL=_sheet.style.js.map
